<template>
  <div class="tw-w-full tw-h-full tw-min-h-screen tw-px-2">
    <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap ">
      <div class="tw-flex tw-items-center tw-bg-white tw-rounded-md tw-w-full md:tw-w-fit">
        <FormField v-model="search" @keyup.enter="onSearch" placeholder="Product ID, Name..." type="text"
          :hide-errors="true" :hide-label="true" class="tw-min-w-[120px] tw-w-full  ltr:!tw-rounded-none tw-peer"
          input-class="ltr:tw-rounded-e-none ltr:tw-border-e-0 rtl:!tw-border-s-0 rtl:tw-rounded-e rtl:tw-border-e rtl:tw-rounded-s-none " />
        <select @change="onPerPageChange" v-model="options.per_page"
          class="tw-min-w-[40px] tw-text-sm tw-outline-none peer-focus-within:tw-border-y-primary-500 peer-focus-within:tw-border-primary-500 tw-border-e tw-rounded-e tw-text-center tw-h-[40px] tw-border tw-border-solid tw-border-gray-200 tw-duration-200">
          <option v-for="item in [2, 5, 10, 20, 50, 75, 100]" :key="item" :value="item" class="tw-px-2">{{ item }}
          </option>
        </select>
      </div>

      <div class="tw-w-full md:tw-w-fit">
        <a-datepicker :placeholder="$t('common.choose-start-date')" v-model="filters.from"
          :position="$i18n.locale == 'ar' ? 'right' : 'left'" class="md:tw-w-fit !tw-w-full"
          input-class="!tw-h-[40px] !tw-text-xs tw-w-full !tw-rounded" :lang="$i18n.locale"></a-datepicker>
      </div>

      <div class="tw-flex-1 md:tw-flex-none">
        <a-datepicker :placeholder="$t('common.choose-end-date')" v-model="filters.to"
          :position="$i18n.locale == 'ar' ? 'right' : 'left'" class="md:tw-w-fit !tw-w-full"
          input-class="!tw-h-[40px] !tw-text-xs tw-w-full !tw-rounded" :lang="$i18n.locale"></a-datepicker>
      </div>

      <a-button @click="onSearch"
        class=" tw-h-[40px] tw-border-s  !tw-border-b peer-focus-within:tw-border-y-primary-500 peer-focus-within:tw-border-e-primary-500 active:!tw-translate-y-0"
        icon="clarity:search-line" intent="icon"></a-button>

      <div class="tw-relative">
        <a-button @click="toggleExchange"
          class="tw-h-[40px] tw-border-s  !tw-border-b active:!tw-translate-y-0 tw-ms-auto"
          icon="hugeicons:money-exchange-02" intent="icon"></a-button>

        <transition class="tw-duration-200" enter-from-class="tw-translate-y-[10px]  tw-opacity-0"
          leave-to-class="tw-translate-y-[10px]  tw-opacity-0">
          <div v-if="visible.exchange">
            <div
              class="tw-w-[250px] tw-h-fit tw-absolute -tw-bottom-1 tw-translate-y-full tw-bg-white tw-rounded-lg tw-border tw-border-b-2">
              <div class="tw-p-2">
                <div class="tw-flex tw-gap-2">
                  <FormField v-model.number="exchange" type="number" :hide-label="true" :hide-errors="true"
                    left-icon="bi:currency-exchange" class="tw-flex-1" />
                  <a-button @click="onExchangeUpdate" 
                    class="tw-h-[40px] tw-border-s !tw-border-b active:!tw-translate-y-0"
                    icon="clarity:search-line" intent="icon"></a-button>
                </div>
              </div>
            </div>
          </div>
        </transition>

      </div>

    </div>

    <div class="tw-mt-2">
      <ProductsTable v-model:filters="filters" v-model:options="options" v-model:sorting="sorting" @next="onNext"
        @prev="onPrevious" @refresh="getData(1)" :search="search" :data="data" :loading="loading" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, provide } from 'vue'
import ProductsTable from './products/ProductsTable.vue';
import FormField from "@/components/form/FormField";
import { products } from '@/api/analytics';

const visible = ref({ exchange: false })
const exchange = ref(localStorage.getItem('exchange') ? parseFloat(localStorage.getItem('exchange')) : 4.88)
const loading = ref(true)
const search = ref('')
const filters = ref({});
const options = ref({ per_page: 10 });
const data = ref([]);
const sorting = ref({
  sortBy: 'total_orders',
  sortDirection: 'desc',
});


watch(filters, () => {
  console.log(typeof filters.value)
}, { deep: true })


const getData = async (page = 1) => {
  loading.value = true;

  await products({ 
    ...filters.value, 
    per_page: options.value.per_page, 
    page, 
    sorting: sorting.value, 
    search: search.value,
    exchange: exchange.value 
  })
    .then(res => {
      data.value = res.data.data.data;
      options.value = res.data.data;
      delete options.value.data
    })
    .catch(err => {
      console.log(err);
    });

  loading.value = false;
};

const toggleExchange = () => {
  visible.value.exchange = !visible.value.exchange
  localStorage.setItem('exchange', exchange.value)

}
const onPerPageChange = () => {
  getData(1)
}
const onNext = () => {
  getData(parseInt(options.value.current_page) + 1)
}
const onPrevious = () => {
  getData(parseInt(options.value.current_page) - 1)
}
const onSearch = () => {
  getData(1)
}

const onExchangeUpdate = () => {
  localStorage.setItem('exchange', exchange.value);
  visible.value.exchange = false;
  getData(1);
};

provide('exchange', exchange)
getData()
</script>

<style></style>